// Turning a member's access off. Members are deactivated, never deleted: the
// audit log and the records they captured keep pointing at them, and an admin
// can turn their access back on. The database repeats these rules in
// app.set_member_active (apps/api/drizzle/*_member_access.sql).
import type { Member } from "./types";

export type DeactivationBlock = "self" | "last_company_admin";

/**
 * Why the user `actorId` cannot turn off the access of `target`, or null if
 * they can. A company always keeps at least one active compliance officer
 * (company admin): without one, nobody could file its notices or manage its team.
 */
export function deactivationBlock(
  members: readonly Member[],
  target: Member,
  actorId: string,
): DeactivationBlock | null {
  if (target.userId === actorId) return "self";
  if (target.role === "company_admin" && !target.deactivatedAt) {
    const otherActiveAdmins = members.filter(
      (m) => m.role === "company_admin" && !m.deactivatedAt && m.userId !== target.userId,
    );
    if (otherActiveAdmins.length === 0) return "last_company_admin";
  }
  return null;
}
